import { createElement } from 'react';
import { aW as GutterContainer$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var GutterContainer = function GutterContainer(props) {
  return /*#__PURE__*/createElement(GutterContainer$1, __assign({}, props));
};
GutterContainer.displayName = 'GutterContainer';

export { GutterContainer };
